import { Store } from '@ngxs/store';
import { NotificationService } from '../../../../../../common/services';
import { AllocationViewSetLastSelectedUliToChanged } from '../../allocation-view.actions';
import {
  AllocationViewActionsCloseActionContainer,
  AllocationViewActionsShouldUpdate,
} from '../allocation-view-actions.actions';
import { Injectable } from '@angular/core';

@Injectable()
export class AllocationViewActionBaseState {
  constructor(protected notificationService: NotificationService, protected store: Store) {}

  finishAction(message: string, closeContainerAfterComplete: boolean = true): void {
    this.store.dispatch(new AllocationViewSetLastSelectedUliToChanged());
    this.store.dispatch(new AllocationViewActionsShouldUpdate());

    if (closeContainerAfterComplete) {
      this.store.dispatch(new AllocationViewActionsCloseActionContainer());
    }

    this.notificationService.success(message);
  }

  setContainerAfterActionEffectsInitialState(): void {
    this.store.dispatch(new AllocationViewActionsShouldUpdate(false));
    this.store.dispatch(new AllocationViewActionsCloseActionContainer(false));
  }
}
